import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { User } from '../../../shared/models/user.model';

import { AuthenticationService } from '../../services/authentication.service';

import { sidebarCollpasedMenu } from '../../helpers/app.helper';
import { environment } from '../../../../environments/environment';
import { timer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { delay, expand, switchMap } from 'rxjs/operators';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit, AfterViewInit {
	public scrollConfig: PerfectScrollbarConfigInterface = {};
	private apiUrl = environment.apiUrl;
	@Input() settings;
	menuItems: Array<any>;
	loginUser: User;
	isSettingsLoad: boolean;
	interval: any;
	statusHRM: any;

	constructor(
		private route: ActivatedRoute,
		private http: HttpClient,
		private authenticationService: AuthenticationService,
	) {
		this.menuItems = this.route.snapshot.data.sidebarMenu.menus;
		this.authenticationService.setLoginUser(this.route.snapshot.data.sidebarMenu.loginUser);
		this.loginUser = this.route.snapshot.data.sidebarMenu.loginUser;
	}

	ngOnInit() {
		// this.interval = timer(0, 10000).pipe().subscribe(x => {
			this.http.get(this.apiUrl+`/api/get-hrm-status`).subscribe((res) => {
				this.statusHRM = res;
			});
		// });
		// this.interval = of(null).pipe(
		// 	expand(() => 
		// 	this.http.get(this.apiUrl + `/api/get-hrm-status`).pipe(
		// 		switchMap(res => {
		// 			this.statusHRM = res;
		// 			return of(null).pipe(delay(60000));
		// 		})
		// 	)
		// 	)
		// ).subscribe();
	}

	ngAfterViewInit() {
		setTimeout(() => {
			sidebarCollpasedMenu();
		});
	}

	logout() {
		this.authenticationService.logout();
	}
}
